<template>
    <div class="change-password-container">
        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <img src="../assets/left-icon.png" alt="back" class="back-icon" @click="goBack" />
            <div class="nav-title">修改密码</div>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 密码输入卡片 -->
        <div class="password-card">
            <div class="input-group">
                <label class="input-label">旧密码</label>
                <input type="password" v-model="oldPassword" placeholder="" class="password-input" />
            </div>

            <div class="input-group">
                <label class="input-label">新密码</label>
                <div class="input-wrapper">
                    <input :type="showNewPassword ? 'text' : 'password'" v-model="newPassword" placeholder=""
                        class="password-input" />
                    <img src="../assets/eye-icon.png" alt="toggle" class="toggle-icon" @click="toggleNewPassword" />
                </div>
            </div>

            <div class="input-group">
                <label class="input-label">再次输入新密码</label>
                <div class="input-wrapper">
                    <input :type="showConfirmPassword ? 'text' : 'password'" v-model="confirmPassword" placeholder=""
                        class="password-input" />
                    <img src="../assets/eye-icon.png" alt="toggle" class="toggle-icon" @click="toggleConfirmPassword" />
                </div>
            </div>
        </div>

        <!-- 保存按钮 -->
        <button class="save-btn" @click="handleSave">保存</button>
    </div>
</template>

<script>
import { systemChangePassword } from '../api/apiList/system';
export default {
    name: 'ChangePassword',
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            showNewPassword: false,
            showConfirmPassword: false
        };
    },
    methods: {
        goBack() {
            this.$router.back();
        },
        toggleNewPassword() {
            this.showNewPassword = !this.showNewPassword;
        },
        toggleConfirmPassword() {
            this.showConfirmPassword = !this.showConfirmPassword;
        },
        async handleSave() {
            if (!this.oldPassword) {
                this.$toast('请输入旧密码')
                return;
            }
            if (!this.newPassword) {
                this.$toast('请输入新密码')
                return;
            }
            if (!this.confirmPassword) {
                this.$toast('请再次输入新密码')
                return;
            }
            if (this.newPassword !== this.confirmPassword) {
                this.$toast('两次输入的新密码不一致')
                return;
            }
            let info = await systemChangePassword({
                old_password: this.oldPassword,
                password: this.newPassword,
                confrimPassword: this.newPassword
            })
            if (info.message) {
                this.$toast('修改密码成功')
                setTimeout(() => {
                    this.$router.back();
                }, 1000)
            }else{
               this.$toast(info.error) 
            }
        }
    }
};
</script>

<style scoped>
.change-password-container {
    width: 100%;
    min-height: 100vh;
    background-color: #000;
    color: #fff;
    padding: 0;
}

/* 顶部导航栏 */
.nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    position: sticky;
    top: 0;
    background-color: #000;
    z-index: 100;
}

.back-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.nav-title {
    font-size: 17px;
    font-weight: 500;
    color: #fff;
}

.nav-placeholder {
    width: 20px;
}

/* 密码输入卡片 */
.password-card {
    background-color: #1a1a1a;
    border-radius: 16px;
    padding: 20px 20px 0;
    margin: 0 20px 20px;
}

.input-group {
    padding: 0 0 20px;
}

.input-label {
    display: block;
    font-size: 15px;
    color: #999;
}

.input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.password-input {
    width: 100%;
    background: transparent;
    border: none;
    border-bottom: 1px solid #333;
    outline: none;
    color: #fff;
    font-size: 15px;
    padding: 10px 30px 10px 0;
}

.password-input::placeholder {
    color: rgba(255, 255, 255, 0.3);
}

.toggle-icon {
    position: absolute;
    right: 0;
    width: 20px;
    height: 20px;
    opacity: 0.5;
    cursor: pointer;
}

.input-divider {
    height: 1px;
    background-color: #2a2a2a;
}

/* 保存按钮 */
.save-btn {
    height: 50px;
    background: linear-gradient(180deg, #36D8AF 0%, #10BDA7 100%);
    border: none;
    border-radius: 25px;
    color: #000;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
}

.save-btn:active {
    opacity: 0.8;
}
</style>
